import { Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "../../../../Services/axiosCommon";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dasboard from "../../../../Components/Icons/Dasboard";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import NuDate from "../../../../Components/Utils/NuDate";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuMobileNumber, NuSelect, NuSelectwithSearch, NuTime } from "../../../../Components/Utils/Input";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";

function CreateRentalManpower({ open, getData, onCancel, data,firstProject  }) {
   const {officeId} = useParams()

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
    const [projectList, setProjectList] = useState([]);
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [createNew, setCreateNew] = useState({
   job_role:"",
    type:"",
    working_hours:"",
    amount_per_hour:""
    
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
          }),  
    onSubmit: async (value, { resetForm }) => {
      axiosInstance
      .post("/manpower-role/", value)
      .then((res) => {
        console.log(res);
        if (res.status === 201 || res.data.status == true) {
          getData();
          resetForm();
          api.success({
            message: `Manpower Creation successfully`,
            description: res?.data?.msg || "Added In The Description",
            placement: "bottomRight",
          });
          onCancel();
        } else {
          api.error({
            message: `Manpower Creation failed`,
            description: res?.data?.msg || "Network error",
            placement: "bottomRight",
          });
        }
      })
      .catch((err) => {
        api.error({
          message: `Manpower Creation failed`,
          description: err?.data?.msg || "Sever error (or) Network error",
          placement: "bottomRight",
        });
      });
  },
});


  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={ "Create Rental Manpower" }
      width={"50%"}
      className="my-modal"
      centered
      onCancel={onCancel}
      footer={[]}
    >
    <form onSubmit={formik.handleSubmit} >
     <div className=" w-full flex flex-wrap">
     <NuInput
              label="Job Role"
              placeholder="Job Role"
              formik={formik}
              name="job_role"
              width="w-full md:w-1/2"
              isRequired={true}
          />
          <FormikSelectTwo
              label="Type"
              Options={[
                {value: 0, label:"Own"},
                {value: 1, label:"Rental"},
              ]}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full md:w-1/2"
          />
           <NuInput
                        type="number"
              label="Working Hours"
              placeholder="Working Hours"
              formik={formik}
              name="working_hours"
              width="w-full md:w-1/2"
             
          />
          
                        <NuInput
                        type="number"
              label="Amount Per Hour"
              placeholder="Amount Per Hour"
              formik={formik}
              name="amount_per_hour"
              width="w-full md:w-1/2"
             
          />
           
<button
              type="submit"
             
              className="w-11/12 bg-textColor-main py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
            >
              Create 
            </button>
          </div>
     
    </form>
    </Modal>
    </>
    // <div className=" w-full h-full py-2 px-4 overflow-hidden">
    //   {contextHolder}
    //   <div className="md:flex justify-end w-full">
    
       
    //     <div className=" flex gap-2 items-center">
    //       <BackButton />
    //     </div>
    //   </div>
    //   <div
    //       className=" w-full mx-auto h-[calc(100vh-145px)] rounded-md mt-2 overflow-y-scroll bg-white"
    //       // style={{ border: "1px solid #C5C5C5" }}
    //     >     <form onSubmit={formik.handleSubmit}>
    //       <div className=' w-full flex flex-wrap rounded-lg my-2'
    //       // style={{ border: "1px solid #ECEBF3" }}
    //       >
    //          <div className="w-full">
    //             <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
    //             Rental ManPower Details :
    //             </p>
    //           </div> 
            
    //                 </div>
    //       <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-8 mt-4 mb-12 md:mr-4">
    //         <CancelButton handleClick={() => navigate(-1)} />
    //         <SubmitButton isLoading={isLoading} />
    //       </div>
    //     </form>
    //   </div>
    // </div>
  );
}

export default CreateRentalManpower;
